import { useImage } from "./Image.hook"
import { useState } from "react"

type ImgOptimizedProps = {
    src: string
    alt?: string
    width?: number | string
    height?: number | string
    className?: string
    title?: string
    imageId?: string
    propertyId?: string
}

export const ImagenOptimizada = ({ src, alt = "", width, height, className = "", title, imageId, propertyId }: ImgOptimizedProps) => {
    const { getImagenOptimizada, notifyError } = useImage()
    const [hasError, setHasError] = useState(false)
    const defaultImg = 'https://cdn4.fincaraiz.com.co/web/66575677eea43_screenshot-2024-05-29-at-11.20.20.png'

    const srcUrl = getImagenOptimizada({
        src: src ?? '',
        width: width ?? 1,
        height: height ?? 1
    })

    const handleError = () => {
        setHasError(true)
        notifyError({
            image_url: src,
            image_id: imageId,
            property_id: propertyId
        })
    }

    const finalSrc = hasError || !srcUrl || srcUrl.length === 0 ? defaultImg : srcUrl

    return <img 
        src={finalSrc}
        alt={alt}
        width={width ?? 'auto'}
        height={height ?? 'auto'}
        className={className}
        title={title}
        onError={handleError}
    />
}